export default "__VITE_ASSET__DAVbYaOU__"